import { USAGE_ANALYTICS_COPY } from '../copy';

/**
 * What a section the server could not compute says instead of its figures — one sentence, never
 * zeros, and never a blank card. `AnalyticsSection` explains why there is no retry beside it.
 */
export const SectionFailure = () => (
  <p className="text-sm text-muted-foreground" data-testid="section-failure">
    {USAGE_ANALYTICS_COPY.sectionFailure}
  </p>
);
